export const toggleModal = "toggleModal"
export const ADD_TEAM_TO_LIST = "ADD_TEAM_TO_LIST"
export const UPDATE_TEAM_IN_LIST = "UPDATE_TEAM_IN_LIST"
export const DELETE_TEAM_FROM_LIST = "DELETE_TEAM_FROM_LIST"
export const ADD_TEAMS_TO_LIST = "ADD_TEAMS_TO_LIST"
